export function hasPerm(perm: string): boolean {
  const permsStr = localStorage.getItem("perms");
  if (!permsStr) return false;

  try {
    const perms = JSON.parse(permsStr); // 解析出来是数组 ["all"] 或 ["add-sku", ...]
    
    if (Array.isArray(perms)) {
      // 核心逻辑：如果列表中包含 "all"，或者包含具体的权限点，则返回 true
      return perms.includes("all") || perms.includes(perm);
    }
  } catch (e) {
    // 容错处理：如果万一存进去的是纯字符串 "all"
    return permsStr === "all";
  }
  return false;
}